import {
  BillingNoteCustomerModel,
  BillingNoteSupplierModel,
  CreditNoteSupplierModel,
  FactCreditNoteSupplierModel,
  FactFinanceCreditModel,
  FactPettyCashWithdrawalModel,
  FactPurchaseReturnModel,
  FactStockIssueModel,
  FactStockMoveModel,
  FactStockPackModel,
  FactStockPoorModel,
  FactStockReturnModel,
  FactStockUnpackModel,
  FinanceCreditModel,
  FinanceDebitModel,
  InvoiceCustomerModel,
  InvoiceSupplierModel,
  NotificationModel,
  OrderModel,
  PettyCashWithdrawalModel,
  PromotionModel,
  PurchaseOrderModel,
  PurchaseRequestModel,
  PurchaseReturnModel,
  ReceiptModel,
  ReceiptPaymentListModel,
  ReceiptRequestCancelModel,
  RedeemGiftModel,
  SaleOrderModel,
  SaleCutOffModel,
  SaleReturnModel,
  SchedulePlanSalesmanModel,
  StockChangeModel,
  StockIssueModel,
  StockMoveModel,
  StockMoveMainModel,
  StockPackModel,
  StockPoorModel,
  StockReturnModel,
  StockRequestModel,
  StockUnpackModel,
  StockVerifyCountModel,
  LicenseModel,
  LeaveModel,
  SalaryPaymentModel,
  SalaryPaySlipModel,
  SaleChangeModel,
  ReceiptReturnListModel,
} from '../../models'

import { dateFunc } from '../../utils'

const billing_note_customer_model = new BillingNoteCustomerModel()
const billing_note_supplier_model = new BillingNoteSupplierModel()
const credit_note_supplier_model = new CreditNoteSupplierModel()
const fact_credit_note_supplier_model = new FactCreditNoteSupplierModel()
const fact_finance_credit_model = new FactFinanceCreditModel()
const fact_petty_cash_withdrawal_model = new FactPettyCashWithdrawalModel()
const fact_purchase_return_model = new FactPurchaseReturnModel()
const fact_stock_issue_model = new FactStockIssueModel()
const fact_stock_move_model = new FactStockMoveModel()
const fact_stock_pack_model = new FactStockPackModel()
const fact_stock_poor_model = new FactStockPoorModel()
const fact_stock_return_model = new FactStockReturnModel()
const fact_stock_unpack_model = new FactStockUnpackModel()
const finance_credit_model = new FinanceCreditModel()
const finance_debit_model = new FinanceDebitModel()
const invoice_customer_model = new InvoiceCustomerModel()
const invoice_supplier_model = new InvoiceSupplierModel()
const notification_model = new NotificationModel()
const order_model = new OrderModel()
const petty_cash_withdrawal_model = new PettyCashWithdrawalModel()
const purchase_order_model = new PurchaseOrderModel()
const purchase_request_model = new PurchaseRequestModel()
const purchase_return_model = new PurchaseReturnModel()
const promotion_model = new PromotionModel()
const redeem_gift_model = new RedeemGiftModel()
const receipt_model = new ReceiptModel()
const receipt_payment_list_model = new ReceiptPaymentListModel()
const receipt_request_model = new ReceiptRequestCancelModel()
const sale_cut_off_model = new SaleCutOffModel()
const sale_order_model = new SaleOrderModel()
const sale_return_model = new SaleReturnModel()
const sale_change_model = new SaleChangeModel()
const receipt_return_list_model = new ReceiptReturnListModel()
const schedule_plan_model = new SchedulePlanSalesmanModel()
const stock_change_model = new StockChangeModel()
const stock_issue_model = new StockIssueModel()
const stock_move_model = new StockMoveModel()
const stock_move_main_model = new StockMoveMainModel()
const stock_pack_model = new StockPackModel()
const stock_poor_model = new StockPoorModel()
const stock_return_model = new StockReturnModel()
const stock_request_model = new StockRequestModel()
const stock_unpack_model = new StockUnpackModel()
const stock_verify_count_model = new StockVerifyCountModel()
const license_model = new LicenseModel()
const leave_model = new LeaveModel()
const salary_payment_model = new SalaryPaymentModel()
const salary_pay_slip_model = new SalaryPaySlipModel()

export default class FetchNotify {
  fetchNotifyBy = async (sections = [], user = {}) => {

    let now = new Date(), y = now.getFullYear(), m = now.getMonth()
    const date_start = new Date(y, m, 1)
    const date_end = new Date(y, m + 1, 0)

    let new_notifys = {}

    let billing_note_customers = {
      waits: [],
      docs: [],
    }

    let billing_note_suppliers = {
      advise_suppliers: [],
      advise_billing_notes: [],
      approves: [],
      issues: [],
    }

    let finance_credits = {
      waits: [],
      docs: [],
    }

    let finance_debits = {
      waits: [],
      docs: [],
    }

    let invoice_customers = {
      advise_customers: [],
      advise_sale_orders: [],
      cancels: [],
      docs: [],
    }

    let petty_cash_withdrawals = {
      advise_petty_cash_withdrawals: [],
      waits: [],
      approves: [],
    }

    let purchase_requests = {
      salesmans: [],
      waits: [],
      approves: [],
      not_approves: [],
      cancels: [],
    }

    let purchase_orders = {
      advise_suppliers: [],
      advise_products: [],
      waits: [],
      approves: [],
      not_approves: [],
      cancels: [],
    }

    let promotions = {
      waits: [],
      approves: [],
    }

    let invoice_suppliers = {
      advise_suppliers: [],
      advise_purchase_orders: [],
      docs: [],
    }

    let purchase_returns = {
      advise_suppliers: [],
      waits: [],
      docs: [],
    }

    let credit_note_suppliers = {
      advises: [],
      waits: [],
      docs: [],
      successes: [],
    }

    let redeem_gifts = {
      waits: [],
      approves: [],
      not_approves: [],
    }

    let schedule_plans = {
      waits: [],
      approves: [],
      not_approves: [],
    }

    let stock_poors = {
      advises: [],
      fixs: [],
      claims: [],
      cancels: [],
    }

    let stock_changes = {
      waits: [],
      approves: [],
      not_approves: [],
    }

    let stock_issues = {
      advises: [],
      waits: [],
      approves: [],
      not_approves: [],
    }

    let stock_moves = {
      advise_stock_groups: [],
      advise_stock_requests: [],
      docs: [],
    }

    let stock_move_mains = {
      requests: [],
      approves: [],
      not_approves: [],
      waits: [],
      successes: [],
      checks: [],
    }

    let stock_returns = {
      advise_stock_issues: [],
      advise_stock_issue_lists: [],
      docs: [],
    }

    let stock_packs = {
      advise_stock_issues: [],
      docs: [],
    }

    let stock_unpacks = {
      advise_stock_issues: [],
      docs: [],
    }
    let receipts = {
      waits: [],
      approves: [],
      docs: [],
    }
    let receipt_payments = {
      waits: [],
      docs: [],
    }

    let receipt_returns = {
      waits: [],
      docs: [],
    }



    let stock_verify_counts = {
      drafts: [],
      waits: [],
      approves: [],
      not_approves: [],
    }

    let leave = {
      waits: [],
      approves: [],
      not_approves: [],
    }

    let salary_payment = {
      waits: [],
      approves: [],
      not_approves: [],
    }

    let salary_pay_slip = {
      waits: [],
      approves: [],
      not_approves: [],
    }

    let notification_setting = {
      seen: [],
      unseen: [],
    }

    let orders = {
      request_check_price: [],
      request_check_slip: [],
      request_check_track: [],
      cancel: [],
      success: [],
      payment_failed: [],
      customer_request_cancel: [],
      order_request_print: [],
      order_print: [],
    }

    let fetching_billing_note_customer = true
    let fetching_billing_note_supplier = true
    let fetching_finance_credit = true
    let fetching_finance_debit = true
    let fetching_invoice_customer = true
    let fetching_petty_cash_withdrawal = true
    let fetching_purchase_request = true
    let fetching_purchase_order = true
    let fetching_invoice_supplier = true
    let fetching_purchase_return = true
    let fetching_promotion = true
    let fetching_credit_note_supplier = true
    let fetching_receipt = true
    let fetching_receipt_payment = true
    let fetching_receipt_return = true
    let fetching_redeem_gift = true
    let fetching_sale_cut_off = true
    let fetching_schedule_plan = true
    let fetching_stock_change = true
    let fetching_stock_issue = true
    let fetching_stock_move = true
    let fetching_stock_move_main = true
    let fetching_stock_pack = true
    let fetching_stock_poor = true
    let fetching_stock_return = true
    let fetching_stock_unpack = true
    let fetching_stock_verify_count = true
    let fetching_all = true
    let fetching_notification_setting = true
    let fetching_order = true
    let fetching_leave = true
    let fetching_salary_payment = true
    let fetching_salary_pay_slip = true

    const licenses = await license_model.getLicenseByCode({
      license_code: user.license_code,
    })

    if (sections.includes('billing-note-customer')) {
      billing_note_customers.waits = await billing_note_customer_model.getAdviseCustomerBillingNoteCustomer({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })


      if (billing_note_customers.waits.require) {
        fetching_billing_note_customer = false
      }

      new_notifys.notify_billing_note_customers = billing_note_customers.waits.notify
      new_notifys.fetching_billing_note_customer = fetching_billing_note_customer
    }

    if (sections.includes('billing-note-supplier')) {
      billing_note_suppliers.advise_suppliers = await billing_note_supplier_model.getAdviseSupplierBillingNoteSupplier({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      billing_note_suppliers.advise_billing_notes = await fact_finance_credit_model.generateFactFinanceCredit({
        group_by: 'group',
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })

      if (billing_note_suppliers.advise_suppliers.require &&
        billing_note_suppliers.advise_billing_notes.require) {
        fetching_billing_note_supplier = false
      }

      const notify_billing_note_supplier_arrs = [billing_note_suppliers.advise_suppliers.notify, billing_note_suppliers.advise_billing_notes.notify,]
      const max_len = Math.max(...notify_billing_note_supplier_arrs)
      new_notifys.notify_billing_note_suppliers = max_len
      new_notifys.fetching_billing_note_supplier = fetching_billing_note_supplier
    }

    if (sections.includes('finance-credit')) {
      finance_credits.waits = await finance_credit_model.getAdviseSupplierFinanceCredit({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (finance_credits.waits.require) {
        fetching_finance_credit = false
      }
      new_notifys.notify_finance_credits = finance_credits.waits.notify
      new_notifys.fetching_finance_credit = fetching_finance_credit
    }

    if (sections.includes('finance-debit')) {
      finance_debits.waits = await finance_debit_model.getAdviseCustomerFinanceDebit({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (finance_debits.waits.require) {
        fetching_finance_debit = false
      }
      new_notifys.notify_finance_debits = finance_debits.waits.notify
      new_notifys.fetching_finance_debit = fetching_finance_debit
    }

    if (sections.includes('invoice-customer')) {
      invoice_customers.advise_customers = await invoice_customer_model.getAdviseCustomerInvoiceCustomer({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      invoice_customers.advise_sale_orders = await invoice_customer_model.getAdviseSaleOrderInvoiceCustomer({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (invoice_customers.advise_customers.require &&
        invoice_customers.advise_sale_orders.require) {
        fetching_invoice_customer = false
      }
      const notify_invoice_customer_arrs = [invoice_customers.advise_customers.notify, invoice_customers.advise_sale_orders.notify]
      const max_len = Math.max(...notify_invoice_customer_arrs)
      new_notifys.notify_invoice_customers = max_len
      new_notifys.fetching_invoice_customer = fetching_invoice_customer
    }

    if (sections.includes('petty-cash-withdrawal')) {
      petty_cash_withdrawals.advise_petty_cash_withdrawals = await fact_petty_cash_withdrawal_model.getFactPettyCashWithdrawalBy({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      petty_cash_withdrawals.waits = await petty_cash_withdrawal_model.getPettyCashWithdrawalBy({
        petty_cash_withdrawal_approve_status: 'Waiting',
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })

      if (petty_cash_withdrawals.advise_petty_cash_withdrawals.require &&
        petty_cash_withdrawals.waits.require) {
        fetching_petty_cash_withdrawal = false
      }
      new_notifys.notify_petty_cash_withdrawals = parseInt(petty_cash_withdrawals.advise_petty_cash_withdrawals.notify) + parseInt(petty_cash_withdrawals.waits.notify)
      new_notifys.fetching_petty_cash_withdrawal = fetching_petty_cash_withdrawal
    }

    if (sections.includes('purchase-request')) {
      purchase_requests.waits = await purchase_request_model.getPurchaseRequestBy({
        purchase_request_approve_status: 'Waiting',
        purchase_request_types: ['employee', 'sub_branch'],
        purchase_request_cancel: 0,
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      purchase_requests.salesmans = await purchase_request_model.getPurchaseRequestBy({
        purchase_request_approve_status: 'Waiting',
        purchase_request_type: 'SALESMAN',
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (purchase_requests.waits.require &&
        purchase_requests.salesmans.require
      ) {
        fetching_purchase_request = false
      }
      new_notifys.notify_purchase_requests = parseInt(purchase_requests.waits.notify) + parseInt(purchase_requests.salesmans.notify)
      new_notifys.fetching_purchase_request = fetching_purchase_request
    }
    if (sections.includes('purchase-order')) {
      purchase_orders.advise_suppliers = await purchase_order_model.getAdviseSupplierPurchaseOrder({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      purchase_orders.advise_products = await purchase_order_model.getAdviseProductPurchaseOrder({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      purchase_orders.waits = await purchase_order_model.getPurchaseOrderBy({
        purchase_order_approve_status: 'Waiting',
        purchase_order_cancel: 0,
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })


      if (purchase_orders.advise_suppliers.require &&
        purchase_orders.advise_products.require &&
        purchase_orders.waits.require
      ) {
        fetching_purchase_order = false
      }

      const notify_purchase_order_arr = [purchase_orders.advise_suppliers.notify, purchase_orders.advise_products.notify,]
      const max_len = Math.max(...notify_purchase_order_arr)

      new_notifys.notify_purchase_orders = parseInt(max_len) + parseInt(purchase_orders.waits.notify)
      new_notifys.fetching_purchase_order = fetching_purchase_order

    }

    if (sections.includes('promotion')) {
      fetching_promotion = false
      new_notifys.fetching_promotion = fetching_promotion
    }

    if (sections.includes('redeem_gift')) {
      fetching_redeem_gift = false
      new_notifys.fetching_redeem_gift = fetching_redeem_gift
    }

    if (sections.includes('invoice-supplier')) {
      invoice_suppliers.advise_suppliers = await invoice_supplier_model.getAdviseSupplierInvoiceSupplier({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      invoice_suppliers.advise_purchase_orders = await invoice_supplier_model.getAdvisePurchaseOrderInvoiceSupplier({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (invoice_suppliers.advise_suppliers.require &&
        invoice_suppliers.advise_purchase_orders.require
      ) {
        fetching_invoice_supplier = false
      }
      const notify_invoice_supplier_arrs = [invoice_suppliers.advise_suppliers.notify, invoice_suppliers.advise_purchase_orders.notify]
      const max_len = Math.max(...notify_invoice_supplier_arrs)
      new_notifys.notify_invoice_suppliers = max_len
      new_notifys.fetching_invoice_supplier = fetching_invoice_supplier
    }

    if (sections.includes('purchase-return')) {
      purchase_returns.advise_suppliers = await fact_purchase_return_model.getFactPurchaseReturnBy({
        notify: true
      })
      purchase_returns.waits = await purchase_return_model.getPurchaseReturnBy({
        purchase_return_delivery_status: '0',
        date_filter_type: 'purchase_return_date',
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (purchase_returns.advise_suppliers.require &&
        purchase_returns.waits.require
      ) {
        fetching_purchase_return = false
      }
      new_notifys.notify_purchase_returns = parseInt(purchase_returns.advise_suppliers.notify) + parseInt(purchase_returns.waits.notify)
      new_notifys.fetching_purchase_return = fetching_purchase_return
    }
    if (sections.includes('credit-note-supplier')) {
      credit_note_suppliers.advises = await fact_credit_note_supplier_model.getFactCreditNoteSupplierBy({
        notify: true
      })
      if (credit_note_suppliers.advises.require
      ) {
        fetching_credit_note_supplier = false
      }
      new_notifys.notify_credit_note_suppliers = credit_note_suppliers.advises.notify
      new_notifys.fetching_credit_note_supplier = fetching_credit_note_supplier
    }

    if (sections.includes('receipt-cancel')) {
      fetching_receipt = false
      new_notifys.fetching_receipt = fetching_receipt
    }
    if (sections.includes('receipt-payment')) {
      receipt_payments.waits = await receipt_payment_list_model.getAdviseCheckReceiptPaymentList({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
      })

      if (receipt_payments.waits.require
      ) {
        fetching_receipt_payment = false
      }

      new_notifys.notify_receipt_payments = receipt_payments.waits.data
      new_notifys.receipt_payments = receipt_payments
      new_notifys.fetching_receipt_payment = fetching_receipt_payment
    }
    if (sections.includes('receipt-return')) {
      receipt_returns.waits = await receipt_model.getAdviseCheckRequestReturn({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
      })

      if (receipt_returns.waits.require
      ) {
        fetching_receipt_return = false
      }

      new_notifys.notify_receipt_returns = receipt_returns.waits.data
      new_notifys.receipt_returns = receipt_returns
      new_notifys.fetching_receipt_return = fetching_receipt_return
    }

    if (sections.includes('sale-cut-off')) {
      const notify_sale_cut_offs = await sale_cut_off_model.getAdviseReceiveSaleCutOff({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (notify_sale_cut_offs.require
      ) {
        fetching_sale_cut_off = false
      }
      new_notifys.notify_sale_cut_offs = notify_sale_cut_offs.notify
      new_notifys.fetching_sale_cut_off = fetching_sale_cut_off
    }

    if (sections.includes('schedule-plan')) {
      schedule_plans.waits = await schedule_plan_model.getSchedulePlanSalesmanBy({
        schedule_plan_salesman_status: 'REQUEST',
        notify: true
      })

      if (schedule_plans.waits.require
      ) {
        fetching_schedule_plan = false
      }
      new_notifys.notify_schedule_plans = schedule_plans.waits.notify
      new_notifys.fetching_schedule_plan = fetching_schedule_plan
    }

    if (sections.includes('stock-change')) {

      fetching_stock_change = false
      new_notifys.fetching_stock_change = fetching_stock_change
    }

    if (sections.includes('stock-issue')) {
      stock_issues.advises = await fact_stock_issue_model.getFactStockIssueBy({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      stock_issues.waits = await stock_issue_model.getStockIssueBy({
        indicator: {
          stock_issue_approve_status: 'Waiting',
          company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        },
        selector: ['stock_issue_type_name', 'user_name',],
        notify: true
      })
      if (stock_issues.advises.require &&
        stock_issues.waits.require
      ) {
        fetching_stock_issue = false
      }
      new_notifys.notify_stock_issues = parseInt(stock_issues.advises.notify) + parseInt(stock_issues.waits.notify)
      new_notifys.fetching_stock_issue = fetching_stock_issue
    }

    if (sections.includes('stock-move')) {
      stock_moves.advise_stock_groups = await fact_stock_move_model.getAdviseStockGroupMoveBy({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        selector: ['stock_group_name',],
        notify: true
      })
      stock_moves.advise_stock_requests = await fact_stock_move_model.getAdviseStockRequestMoveBy({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        selector: ['stock_group_name', 'stock_request_remark',],
        notify: true
      })
      stock_moves.waits = await stock_move_model.getStockMoveBy({
        indicator: {
          company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
          stock_move_approve_status: 'Waiting',
        },
        selector: ['stock_group_out_name', 'stock_group_in_name', 'user_name',],
        notify: true
      })
      const notify_stock_move_arrs = [stock_moves.advise_stock_groups.notify, stock_moves.advise_stock_requests.notify, stock_moves.waits.notify]
      const max_len = Math.max(...notify_stock_move_arrs)
      if (stock_moves.waits.require &&
        stock_moves.advise_stock_requests.require &&
        stock_moves.advise_stock_groups.require
      ) {
        fetching_stock_move = false
      }
      new_notifys.notify_stock_moves = max_len
      new_notifys.fetching_stock_move = fetching_stock_move
    }

    if (sections.includes('stock-move-main')) {
      stock_move_mains.requests = await stock_move_main_model.getStockMoveMainBy({
        indicator: {
          stock_move_main_status: 'request',
          company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        },
        selector: ['stock_group_out_name', 'stock_group_in_name', 'user_name',],
        notify: true
      })
      if (stock_move_mains.requests.require
      ) {
        fetching_stock_move_main = false
      }
      new_notifys.notify_stock_move_mains = stock_move_mains.requests.notify
      new_notifys.fetching_stock_move_main = fetching_stock_move_main
    }
    if (sections.includes('stock-pack')) {
      stock_packs.advise_stock_issues = await fact_stock_pack_model.getFactStockPackBy({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (stock_packs.advise_stock_issues.require
      ) {
        fetching_stock_pack = false
      }
      new_notifys.notify_stock_packs = stock_packs.advise_stock_issues.notify
      new_notifys.fetching_stock_pack = fetching_stock_pack
    }

    if (sections.includes('stock-poor')) {
      stock_poors.advises = await fact_stock_poor_model.getFactStockPoorBy({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (stock_poors.advises.require
      ) {
        fetching_stock_poor = false
      }
      new_notifys.notify_stock_poors = stock_poors.advises.notify
      new_notifys.fetching_stock_poor = fetching_stock_poor
    }

    if (sections.includes('stock-return')) {
      stock_returns.advise_stock_issues = await fact_stock_return_model.getAdviseStockIssueReturnBy({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (stock_returns.advise_stock_issues.require
      ) {
        fetching_stock_return = false
      }
      new_notifys.notify_stock_returns = stock_returns.advise_stock_issues.notify
      new_notifys.fetching_stock_return = fetching_stock_return
    }

    if (sections.includes('stock-unpack')) {
      stock_unpacks.advise_stock_issues = await fact_stock_unpack_model.getFactStockUnpackBy({
        company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        notify: true
      })
      if (stock_unpacks.advise_stock_issues.require
      ) {
        fetching_stock_unpack = false
      }
      new_notifys.notify_stock_unpacks = stock_unpacks.advise_stock_issues.notify
      new_notifys.fetching_stock_unpack = fetching_stock_unpack
    }

    if (sections.includes('stock-verify-count')) {
      stock_verify_counts.waits = await stock_verify_count_model.getStockVerifyCountBy({
        indicator: {
          user_branch_code: user.user_branch_code,
          stock_verify_count_approve_status: 'Waiting',
          company_branch_code: licenses.data[0].branch_status === 'my-branch' ? user.user_branch_code : licenses.data[0].branch_status === 'all-branch' ? '' : '',
        },
        selector: ['stock_group_name', 'user_name',],
        notify: true
      })
      if (stock_verify_counts.waits.require) {
        fetching_stock_verify_count = false
      }

      new_notifys.notify_stock_verify_counts = stock_verify_counts.waits.notify
      new_notifys.fetching_stock_verify_count = fetching_stock_verify_count
    }

    if (sections.includes('leave')) {
      fetching_leave = false
      new_notifys.fetching_leave = fetching_leave
    }

    if (sections.includes('salary-payment')) {

      fetching_salary_payment = false
      new_notifys.fetching_salary_payment = fetching_salary_payment
    }


    if (sections.includes('salary-pay-slip')) {
      fetching_salary_pay_slip = false
      new_notifys.fetching_salary_pay_slip = fetching_salary_pay_slip
    }

    // if (sections.length || sections.includes('notification')) {
    //   const notifications = await notification_model.getNotificationBy({
    //     user_code: user.user_code,
    //     notification_seen: '0',
    //     notification_to: 'backoffice',
    //     limit: 99
    //   })

    //   new_notifys.notifications = notifications
    // }

    if (sections.length || sections.includes('order')) {
      orders.request_check_price = await order_model.getOrderBy({
        order_status: 'request_check_price',
        notify: true
      })
      if (orders.request_check_price.require) {
        fetching_order = false
      }
      new_notifys.notify_orders = orders.request_check_price.notify
      new_notifys.fetching_order = fetching_order
    }

    if (sections.length) {
      notification_setting.unseen = await notification_model.getNotificationBy({
        user_code: user.user_code,
        notification_seen: '0',
        notify: true
      })

      if (notification_setting.unseen.require
      ) {
        fetching_notification_setting = false
      }

      new_notifys.notify_notification_setting = notification_setting.unseen.notify
      new_notifys.fetching_notification_setting = fetching_notification_setting
    }

    if (sections.length === 34) {
      if (!fetching_billing_note_customer &&
        !fetching_billing_note_supplier &&
        !fetching_finance_credit &&
        !fetching_finance_debit &&
        !fetching_invoice_customer &&
        !fetching_petty_cash_withdrawal &&
        !fetching_purchase_request &&
        !fetching_purchase_order &&
        !fetching_invoice_supplier &&
        !fetching_purchase_return &&
        !fetching_credit_note_supplier &&
        !fetching_receipt &&
        !fetching_stock_return &&
        !fetching_receipt_payment &&
        !fetching_sale_cut_off &&
        !fetching_schedule_plan &&
        !fetching_stock_issue &&
        !fetching_stock_change &&
        !fetching_stock_move &&
        !fetching_stock_move_main &&
        !fetching_stock_pack &&
        !fetching_stock_poor &&
        !fetching_stock_return &&
        !fetching_stock_unpack &&
        !fetching_stock_verify_count &&
        !fetching_notification_setting &&
        !fetching_order &&
        !fetching_leave &&
        !fetching_salary_payment &&
        !fetching_salary_pay_slip
      ) { fetching_all = false }
      new_notifys.fetching_all = fetching_all
    }

    return new_notifys
  }
}